<wdx-avatar wdxAvatar [avatar]="avatar" [size]="'xl'" class="me-2"></wdx-avatar>
<div class="d-flex flex-column">
    <h6>{{ content?.name }}</h6>
    @if (content?.badge?.status) {
        <wdx-badge
            [themeColor]="$any(content?.badge?.themeColor)"
            [attr.data-cy]="'avatar-popup-status-badge'"
        >
            {{ content?.badge?.status }}
        </wdx-badge>
    }
    @if (content?.info) {
        <div [attr.data-cy]="'avatar-popup-info'">
            {{ $any(content?.info) | titleCase }}
        </div>
    }
    @for (
        phoneNumber of content?.phoneNumbers;
        track $index;
        let i = $index
    ) {
        <a
            [attr.href]="'tel:' + phoneNumber"
            [attr.data-cy]="'avatar-popup-phone-number-' + i"
        >
            {{ phoneNumber }}
        </a>
    }
    @for (email of content?.emails; track $index; let i = $index) {
        <a
            [attr.href]="'mailto:' + email"
            [attr.data-cy]="'avatar-popup-email-' + i"
        >
            {{ email }}
        </a>
    }
</div>
